import axios from 'axios';
import Cookies from 'js-cookie';

// Axios auth config 

const getConfig = () => { 

    const token = Cookies.get('jwt');

    const config = { 
        headers: {
            Authorization: `Bearer ${token}`,
        },
    }; 

    return config; 

}; 

// -- 

const getBlobHeadersConfig = () => { 

    const token = Cookies.get('jwt');

    const config = { 
        headers: {
            Authorization: `Bearer ${token}`
        },
        responseType: 'blob'
    }; 

    return config as any; 

}; 

// -- 

export const getGroupMemberInfo = async (groupAccessId: any) => {

    try {

        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/doctor/account/group/member/${groupAccessId}`, getConfig()); 

        return res;

    } catch (error) {
        console.error('Error retrieving a doctor info..', error);
    };

};

// -- 

export const getGroupList = async () => { 

    try {

        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/doctor/group/list`, getConfig());

        return res; 

    } catch (error) {
        console.error('Error GET group list.', error);
    };

};

// -- 

export const getGroupAccess = async (groupAccessId: string) => { 

    try {

        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/doctor/group/access/${groupAccessId}`, getConfig());

        return res; 

    } catch (error) {
        console.error('Error GET group access.', error);
    };

};

// -- 

export const createGroupAccess = async (firstName: string, lastName: string, email: string) => {

    try {

        const content = { 
            firstName: firstName, 
            lastName: lastName, 
            email: email,
        }; 

        const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/doctor/group/access`, content, getConfig()); 

        return res; 

    } catch (error) {
        console.error('Error creating a new account:', error);
    };

};

// -- 

interface UpdateGroupAccessProps { 
    groupAccessId: string; 
    status?: string;
    isDeleteGroupAccess?: boolean;  
}; 

export const updateGroupAccess = async (content: UpdateGroupAccessProps) => { 

    try {

        const res = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/doctor/group/access/${content.groupAccessId}`, content, getConfig());

        return res; 

    } catch (error) {
        console.error('Error PUT group access.', error);
    };

};

// -- 

export const deleteGroupAccess = async (groupAccessId: string) => { 

    try {

        const res = await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/doctor/group/access/${groupAccessId}`, getConfig());

        return res; 

    } catch (error) {
        console.error('Error DELETE group access.', error);
    };

};

// --

export const getGroupAccessWithDoctorId = async (doctorId: string) => { 

    try {

        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/doctor/group/access/doctor/${doctorId}`, getConfig());

        return res; 

    } catch (error) {
        console.error('Error GET group access with doctor Id.', error);
    };

};

// -- 

export const verifyGroupAccessEmail = async (email: string) => { 

    try {

        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/doctor/group/access/email/${email}`, getConfig());

        return res; 

    } catch (error) {
        console.error('Error GET group access with doctor Id.', error);
    };

};

// -- 

export const inviteDoctorToGroup = async (email: string) => { 

    try {

        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/doctor/group/access/invite/${email}`, getConfig());

        return res; 

    } catch (error) {
        console.error('Error GET group access with doctor Id.', error);
    };

};

// --

interface DoctorLogsProps { 
    type: string; 
    device?: string; 
    page?: string; 
    description?: string; 
}; 

export const generateDoctorLog = async (config: DoctorLogsProps) => {

    try {

        const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/doctor/log`, config, getConfig()); 

        return res; 

    } catch (error) {
        console.error('Error creating a doctor log:', error);
    };

};

// -- 

// -- 

export const requestAccountDeletion = async () => { 

    try {

        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/doctor/account/deletion/request`, getConfig());

        return res; 

    } catch (error) {
        console.error('Error requesting account deletion', error);
    };

};

// -- 

export const confirmAccountDeletion = async (authCode: any, deletedAccountId: any) => { 

    try {

        const content = { 
            authCode, 
            deletedAccountId
        }; 

        const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/doctor/account/deletion/request`, content, getConfig());

        return res; 

    } catch (error) {
        console.error('Error confirming account deletion', error);
    };

};



